import type { Workspace } from 'prove-common'

/** Unknown IDs are not evidence of inactivity (the lookup may still be loading). */
export function workspaceLabel(
  id: number,
  workspaces: Workspace[] | undefined
): string {
  const workspace = workspaces?.find((item) => item.id === id)
  const name = workspace?.name ?? `Arbeidsområde ${id}`
  return workspace?.active === false ? `${name} (inaktivt)` : name
}

/** Offer active workspaces, plus only the existing values relevant to this plan. */
export function planWorkspaceOptions(
  workspaces: Workspace[] | undefined,
  retainedIds: (number | null | undefined)[]
): { id: number; name: string }[] {
  const ids = new Set(
    workspaces?.filter((item) => item.active).map((item) => item.id)
  )
  for (const id of retainedIds) {
    if (id != null) ids.add(id)
  }
  return Array.from(ids, (id) => ({ id, name: workspaceLabel(id, workspaces) }))
}
